<div class="main-header main-landing text-center">
  <div
    class="swiper-container swiper-swiper-unique-id-4 initialized swiper-container-horizontal"
    data-slide="fade"
    data-effect="fade"
    [attr.data-autoplay]="sliders?.length > 1 ? 7000 : null"
  >
    <div *ngIf="sliders?.length > 1" class="btn-prev-without">
      <svg class="olymp-popup-left-arrow">
        <use
          xlink:href="assets/svg-icons/sprites/icons.svg#olymp-popup-left-arrow"
        ></use>
      </svg>
    </div>
    <div *ngIf="sliders?.length > 1" class="btn-next-without">
      <svg class="olymp-popup-right-arrow">
        <use
          xlink:href="assets/svg-icons/sprites/icons.svg#olymp-popup-right-arrow"
        ></use>
      </svg>
    </div>
    <div class="swiper-wrapper">
      <div class="swiper-slide" *ngFor="let slider of sliders; let i = index">
        <div class="slide-container">
          <div class="container-text-slide">
            <div class="container m-0 p-0">
              <div class="title-header" data-swiper-parallax="-500">
                <div class="title">
                  <h1>{{ slider.name }}</h1>
                  <!-- <div class="info">
										<span *ngIf="slider.startingDate"><i class="far fa-calendar-alt"></i> {{slider.startingDate | date:'longDate'}}</span>
										<span *ngIf="slider.location"><i class="fas fa-map-marker-alt"></i> {{slider.location}}</span>
									</div> -->
                </div>

                <div class="desc">
                  {{ slider.shortDescription | translatedDescription }}
                </div>

                <a
                  *ngIf="slider.id != null"
                  [routerLink]="slider.id ? '/events/' + slider.id : '/events'"
                  class="btn btn-primary btn-lg size-20"
                >
                  {{ "INSCRIPTION" | translate }}
                  <i class="far fa-long-arrow-right"></i>
                  <div class="ripple-container"></div>
                </a>

                <a
                  *ngIf="slider.id == null"
                  [routerLink]="'/authentication/sign-up'"
                  class="btn btn-primary btn-lg size-20"
                >
                  {{ "INSCRIPTION" | translate }}
                  <i class="far fa-long-arrow-right"></i>
                  <div class="ripple-container"></div>
                </a>
              </div>
            </div>
          </div>

          <div class="image-cover" data-swiper-parallax="-100">
            <img
              [src]="
                slider.sliderCover ? slider.sliderCover : slider.imageCover
              "
            />
          </div>
        </div>
      </div>
    </div>

    <!-- If we need pagination -->
    <div class="swiper-pagination"></div>
  </div>
</div>
<section>
  <div class="container">
    <div class="row mt50">
      <div class="col col-xl-4 col-lg-4 m-auto col-md-12 col-sm-12 col-12">
        <div class="crumina-module crumina-heading align-center">
          <h2 class="h1 heading-title mb-0">Africa CEO Platform</h2>
        </div>
      </div>
    </div>
    <div class="row mt20">
      <div class="col col-xl-10 col-lg-10 m-auto col-md-12 col-sm-12 col-12">
        <div class="crumina-module crumina-heading align-center">
          <p class="size-18">{{ "APPLCIATION_DETAILS_PART_1" | translate }}</p>
          <p class="size-18">{{ "APPLCIATION_DETAILS_PART_2" | translate }}</p>
          <p class="size-18">{{ "APPLCIATION_DETAILS_PART_3" | translate }}</p>
        </div>
      </div>
    </div>
    <section *ngIf="events?.length > 0">
      <div class="container">
        <div class="row mt50">
          <div class="col col-xl-4 col-lg-4 m-auto col-md-12 col-sm-12 col-12">
            <div class="crumina-module crumina-heading align-center">
              <h2 class="h1 heading-title mb-0">
                {{ "COMING_EVENTS" | translate }}
              </h2>
            </div>
          </div>
        </div>

        <div class="row">
          <ng-container *ngIf="events?.length > 3">
            <div class="swiper-container pagination-bottom" data-show-items="3">
              <div class="swiper-wrapper">
                <div class="swiper-slide" *ngFor="let event of events">
                  <app-event-card [event]="event"></app-event-card>
                </div>
              </div>

              <div class="swiper-pagination"></div>
            </div>
          </ng-container>
          <ng-container *ngIf="events?.length <= 3">
            <div
              class="col col-xl-4 col-lg-4 m-auto col-md-12 col-sm-12 col-12"
              *ngFor="let event of events"
            >
              <app-event-card [event]="event"></app-event-card>
            </div>
          </ng-container>
        </div>
      </div>
    </section>
    <!-- Annuaire -->
    <div class="row align-items-center justify-content-center my-5 mt-lg-3">
      <div class="col-12 col-lg-6 col-md-12">
        <h3>{{ "APPLICATION_DETAILS_DIRECTORY" | translate }}</h3>
        <p class="size-18">
          {{ "APPLICATION_DETAILS_DIRECTORY_CONTENT" | translate }}
        </p>
        <a
          class="nav-link pl-0 underline-text size-18"
          [routerLink]="'/authentication/sign-up'"
        >
          <i class="fas fa-arrow-right"></i>
          {{ "APPLICATION_DETAILS_DIRECTORY_LINK" | translate }}
        </a>
      </div>
      <div class="col-12 col-lg-6 col-md-12 p-5">
        <img src="assets/img/annuaire.png" alt="Annuaire" width="100%" />
      </div>
    </div>
    <!-- Oppurtunite -->
    <div class="row align-items-center justify-content-center my-3">
      <div class="col-12 col-lg-6 col-md-12 p-5">
        <img
          src="assets/img/oppurtunites.png"
          alt="opportunites"
          width="100%"
        />
      </div>
      <div class="col-12 col-lg-6 col-md-12">
        <h3>{{ "APPLICATION_DETAILS_OPPORTUNITY" | translate }}</h3>
        <p class="size-18">
          {{ "APPLICATION_DETAILS_OPPORTUNITY_CONTENT" | translate }}
        </p>
        <a
          class="nav-link pl-0 underline-text size-18"
          [routerLink]="'/authentication/sign-up'"
        >
          <i class="fas fa-arrow-right"></i>
          {{ "APPLICATION_DETAILS_OPPORTUNITY_LINK" | translate }}
        </a>
      </div>
    </div>

    <!-- Event -->
    <div class="row align-items-center justify-content-center my-5 my-lg-3">
      <div class="col-12 col-lg-6 col-md-12">
        <h3>{{ "APPLICATION_DETAILS_EVENTS" | translate }}</h3>
        <p class="size-18">
          {{ "APPLICATION_DETAILS_EVENTS_CONTENT" | translate }}
        </p>
        <a
          class="nav-link pl-0 underline-text size-18"
          [routerLink]="'/authentication/sign-up'"
        >
          <i class="fas fa-arrow-right"></i>
          {{ "APPLICATION_DETAILS_EVENTS_LINK" | translate }}
        </a>
      </div>
      <div class="col-12 col-lg-6 col-md-12 p-5">
        <img src="assets/img/events.png" alt="events" width="100%" />
      </div>
    </div>
    <!-- Chat -->
    <div class="row align-items-center justify-content-center my-3">
      <div class="col-12 col-lg-6 col-md-12 p-5">
        <img src="assets/img/chat_image.png" alt="chat_image" width="100%" />
      </div>
      <div class="col-12 col-lg-6 col-md-12">
        <h3>{{ "APPLICATION_DETAILS_CHAT" | translate }}</h3>
        <p class="size-18">
          {{ "APPLICATION_DETAILS_CHAT_CONTENT" | translate }}
        </p>
        <a
          class="nav-link pl-0 underline-text size-18"
          [routerLink]="'/authentication/sign-up'"
        >
          <i class="fas fa-arrow-right"></i>
          {{ "APPLICATION_DETAILS_CHAT_LINK" | translate }}
        </a>
      </div>
    </div>
  </div>
</section>

<section *ngIf="assets && assets['SPONSOR']?.length > 0">
  <div class="container">
    <div class="row mt50">
      <div class="col col-xl-4 col-lg-4 m-auto col-md-12 col-sm-12 col-12">
        <div class="crumina-module crumina-heading align-center">
          <h2 class="h1 heading-title mb-0">
            {{ "OUR_SPONSORS" | translate }}
          </h2>
        </div>
      </div>
    </div>
    <div class="row">
      <ng-container>
        <div
          class="swiper-container pagination-bottom"
          [attr.data-show-items]="getAssetsShow(assets['SPONSOR']?.length)"
        >
          <div class="swiper-wrapper">
            <div
              class="swiper-slide text-center"
              *ngFor="let sponsor of assets['SPONSOR']"
            >
              <img
                [src]="sponsor.image"
                alt="chat_image"
                [attr.width]="getAssetsImageWidth(assets['SPONSOR']?.length)"
              />
            </div>
          </div>
          <div
            *ngIf="assets['SPONSOR']?.length > 2"
            class="swiper-pagination"
          ></div>
        </div>
      </ng-container>
    </div>
  </div>
</section>

<!-- <section *ngIf="events?.length > 0">
	<div class="container">
		<div class="row mt50">
			<div class="col col-xl-4 col-lg-4 m-auto col-md-12 col-sm-12 col-12">
				<div class="crumina-module crumina-heading align-center">

					<h2 class="h1 heading-title mb-0">{{'COMING_EVENTS' | translate}}</h2>
				</div>
			</div>
		</div>

		<div class="row">
			<ng-container *ngIf="events?.length > 3">
				<div class="swiper-container pagination-bottom" data-show-items="3">
					<div class="swiper-wrapper">
						<div class="swiper-slide" *ngFor="let event of events">
							<app-event-card [event]="event"></app-event-card>
						</div>
					</div>

					<div class="swiper-pagination"></div>
				</div>
			</ng-container>
			<ng-container *ngIf="events?.length <= 3">
				<div class="col col-xl-4 col-lg-4 m-auto col-md-12 col-sm-12 col-12" *ngFor="let event of events">
					<app-event-card [event]="event"></app-event-card>
				</div>
			</ng-container>
		</div>
	</div>
</section> -->

<section *ngIf="assets && assets['PARTNER']?.length > 0">
  <div class="container">
    <div class="row mt50">
      <div class="col col-xl-4 col-lg-4 m-auto col-md-12 col-sm-12 col-12">
        <div class="crumina-module crumina-heading align-center">
          <h2 class="h1 heading-title mb-0">
            {{ "OUR_PARTNERS" | translate }}
          </h2>
        </div>
      </div>
    </div>
    <div class="row">
      <ng-container>
        <div
          class="swiper-container pagination-bottom"
          [attr.data-show-items]="getAssetsShow(assets['PARTNER']?.length)"
        >
          <div class="swiper-wrapper">
            <div
              class="swiper-slide text-center"
              *ngFor="let partner of assets['PARTNER']"
            >
              <img
                [src]="partner.image"
                alt="chat_image"
                [attr.width]="getAssetsImageWidth(assets['PARTNER']?.length)"
              />
            </div>
          </div>
          <div
            *ngIf="assets['PARTNER']?.length > 2"
            class="swiper-pagination"
          ></div>
        </div>
      </ng-container>
    </div>
  </div>
</section>
